const data = {
    name: "Nasser Hussein", 
    links: {
        github: "https://github.com/nhussein2026",
        linkedin: "https://www.linkedin.com/in/nhussein2026",

    },
    email: "naser738nas@gmail.com",
    socialMedia: [
        {
            name: "Github",
            link: "https://github.com/nhussein2026"
        },
        {
            name: "LinkedIn",
            link: "https://www.linkedin.com/in/nhussein2026"
        }
    ],

    navLinks: [
        {
            name: "About",
            link: "/#about"
        },
        {
            name: "Experience",
            link: "/#experience"
        },
        {
            name: "Projects",
            link: "/#projects"
        },
        {
            name: "Contact",
            link: "/#contact"
        }
    ],

    colors: {
        navy: '#0a192f',
        darkNavy: '#020c1b',
    }


}
export default data;